import { GuidesPage } from "../../GuidesPage";
import { seoContent } from "../../../../constants/SEOConstant";
import { PairSyncGuideContent } from "../../PairSyncGuideContent";

export default function SyncSpotifyToSpotify() {
    return (
        <GuidesPage
            seoData={seoContent.syncSpotifyToSpotify}
            sections={<PairSyncGuideContent sourceKey="spotify" destKey="spotify" />}
        />
    );
}
